import { Paper, Text, Title } from "@mantine/core";
import { EditIcon } from "../../shared/svg";
import "./Profile.scss";
import useProfileStore from "../../store/useProfileStore";
import useAuthStore from "../../store/useAuthStore";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

export const Hobbies = () => {
  const { profile } = useProfileStore();
  const hobbies = profile?.hobbies || [];
  const { cvProcessing } = useAuthStore();
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Paper withBorder radius="24px" p={32} h="100%" pos="relative">
      <div
        className="edit-icon"
        onClick={() => navigate("/profile/edit/hobby")}
      >
        <EditIcon />
      </div>
      <Title size={36} lh="50px">
        {t("hobby")}
      </Title>

      {hobbies.length > 0 ? (
        hobbies.map((item, index) => {
          return (
            <div key={index}>
              <Title
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "block",
                  maxWidth: "100%",
                }}
                size={24}
                mt={40}
              >
                {item.name || t("unknown")}
              </Title>
              {item.description && (
                <Text
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "block",
                    maxWidth: "100%",
                  }}
                  mt={8}
                >
                  {item.description}
                </Text>
              )}
            </div>
          );
        })
      ) : (
        <Text mt={30} c="#737373">
          {cvProcessing !== "processing" ? t("no_hobbies") : t("no_hobbies_cv")}
        </Text>
      )}
    </Paper>
  );
};
